import { render } from "./relationship.vue?vue&type=template&id=6184b564&scoped=true"
import script from "./relationship.vue?vue&type=script&lang=js"
export * from "./relationship.vue?vue&type=script&lang=js"

import "./relationship.vue?vue&type=style&index=0&id=6184b564&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6184b564"]])

export default __exports__